module.exports = __webpack_public_path__ + "img/cam.3e017798.svg";